export default [
  {
    path: "/intoOther", //走进***
    name: "intoOther",
    component: () =>
      import("@/view/CloudFair/Government/secondPage/other/intoOther.vue"),
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/investmentOther", //投资***
    name: "investmentOther",
    component: () =>
      import("@/view/CloudFair/Government/secondPage/other/investmentOther.vue"),
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/industryPlatformOther", //产业平台
    name: "industryPlatformOther",
    component: () =>
      import("@/view/CloudFair/Government/secondPage/other/industryPlatformOther.vue"),
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/investmentMapOther", //招商平台
    name: "investmentMapOther",
    component: () =>
      import("@/view/CloudFair/Government/secondPage/other/investmentMapOther.vue")
  },
  {
    path: "/projectOther", //项目清单
    name: "projectOther",
    component: () =>
      import("@/view/CloudFair/Government/secondPage/other/projectOther.vue"),
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/investmentPolicyOther", //投资政策
    name: "investmentPolicyOther",
    component: () =>
      import("@/view/CloudFair/Government/secondPage/other/investmentPolicyOther.vue"),
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/investmentServicesOther", //展会活动
    name: "investmentServicesOther",
    component: () =>
      import("@/view/CloudFair/Government/secondPage/other/investmentServicesOther.vue")
  },
  {
    path: "/contactUsOther", //联系我们
    name: "contactUsOther",
    component: () =>
      import("@/view/CloudFair/Government/secondPage/other/contactUsOther.vue")
  },
  {
    path: "/investmentServiceInfoOther", //数据详情
    name: "investmentServiceInfoOther",
    component: () =>
      import("@/view/CloudFair/Government/secondPage/other/info/investmentServiceInfoOther.vue")
  },
  {
    path: "/AreaDetail", //数据详情
    name: "AreaDetail",
    component: () =>
      import("@/view/CloudFair/Government/Detail/detail.vue")
  },
  {
    path: "/activeDetail", //展会活动详情
    name: "activeDetail",
    component: () =>
      import("@/view/CloudFair/Government/secondPage/other/info/activeDetail.vue")
  }
];



// WEBPACK FOOTER //
// ./src/router/cloudFair/other.js